import { zSidLabel } from "src/types";
import { Scalar } from "src/types/Scalar";

export const getScalarValue = (value: unknown): Scalar => {
  switch (typeof value) {
    case "boolean":
    case "string":
    case "number":
      return value;
    case "object": {
      const res = zSidLabel.safeParse(value);
      return res.success ? res.data.id : null;
    }
    default:
      break;
  }
  return null;
};
